/* eslint-disable complexity */
/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { PreviewWidgetFrame } from '@/components/preview/PreviewWidgetFrame';
import { ContentItem } from '@/data/types/LayoutAllSlots';
// eslint-disable-next-line no-restricted-imports
import { getContentNameFromWidgetName } from '@/data/utils/getContentNameFromWidgetName';
import { findElementByContentItem } from '@/utils/findElementByContentItem';
import { FC } from 'react';

type Props = {
	slot?: ContentItem[];
	SlotWrap?: FC;
	ItemWrap?: FC;
};

const NullElement: FC = () => null;

const FragmentWrap: FC<{ children?: JSX.Element | JSX.Element[] }> = ({ children }) => (
	<>{children}</>
);

export const LayoutSlot: FC<Props> = ({ slot, SlotWrap = FragmentWrap, ItemWrap = FragmentWrap }) =>
	slot ? (
		<SlotWrap>
			{slot.map((contentItem) => {
				const { name, id, properties, widgetRaw } = contentItem;
				const nameNormalized = getContentNameFromWidgetName(name);
				const Element = findElementByContentItem(contentItem);

				return Element ? (
					widgetRaw ? (
						<ItemWrap key={nameNormalized + id + properties?.emsName}>
							<PreviewWidgetFrame widget={{ ...widgetRaw, dataId: id }}>
								<Element id={id} properties={properties} />
							</PreviewWidgetFrame>
						</ItemWrap>
					) : (
						<ItemWrap key={nameNormalized + id + properties?.emsName}>
							<Element id={id} properties={properties} />
						</ItemWrap>
					)
				) : (
					<NullElement key={nameNormalized + id + properties?.emsName} />
				);
			})}
		</SlotWrap>
	) : null;
